module.exports = __webpack_public_path__ + "static/img/fireworks.c194e384.gif";